'use strict';

/**
 * @classname SpMenu
 * @classdesc TOPパララックス
 */
export default class SpMenu {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('SpMenu.constructor');
		this._$e = $e;
		this._$menu = $('.list--menu');
		this._$background = $('.aside--menu');
		$e.on('click', () => {
			this.onClick();
		});
	};


	/**
	 * クリックイベントのコールバック
	 *
	 * @memberof SpMenu
	 * @return {undefined}
	 */
	onClick() {
		console.log('SpMenu.onClick');
		if(this._$background.hasClass('open')){
			this.close();
		}else{
			this.open();
		}
	};


	/**
	 * メニューを開く
	 *
	 * @memberof SpMenu
	 * @return {undefined}
	 */
	open() {
		console.log('SpMenu.open');
		this._$background.show().addClass('open');
		this._$menu.animate({'right': '0'});
	};


	/**
	 * メニューを閉じる
	 *
	 * @memberof SpMenu
	 * @return {undefined}
	 */
	close() {
		console.log('SpMenu.close');
		this._$background.removeClass('open');
		this._$menu.animate({'right': '-90vw'});
		setTimeout(() => {
			this._$background.hide();
		}, 300);
	};
};